module.exports = __webpack_public_path__ + "static/radial_gradient-9112fda416db44f8c45afb967b944d80.png";